import $ from "jquery";
$(function () {
    var $overlay = $("#menuOverlay");
    var $btnToggle = $("#menuToggleBtn");
    var $btnCloseMobile = $("#menuCloseBtn");
    var $btnCloseDesktop = $("#menuCloseBtnDesktop");
    var $body = $("body");
    function setMenu(open) {
        if ($overlay.length === 0)
            return;
        $overlay.toggleClass("d-none", !open);
        $body.toggleClass("overflow-hidden", open);
        $overlay.attr("aria-hidden", (!open).toString());
    }
    $btnToggle.on("click", function () { return setMenu(true); });
    $btnCloseMobile.on("click", function () { return setMenu(false); });
    $btnCloseDesktop.on("click", function () { return setMenu(false); });
    // klik mimo obsahu – zavrie overlay (môžeš vypnúť ak nechceš)
    $overlay.on("click", function (e) {
        if (e.target === $overlay[0]) {
            setMenu(false);
        }
    });
    // ESC
    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            setMenu(false);
        }
    });
});
//# sourceMappingURL=menu.js.map